import { Spinner } from "@nextui-org/react"

function LoadingCard() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner size="lg" label="Loading..." labelColor="primary" />
    </div>
  )
}
export default LoadingCard